const MarcoPollo = () => {
    return (
      <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
        <h1>Marco Pollo</h1>
  
        <p>
          When travelling recently through South America and Asia, I realised finding a great place to eat can take sometimes take longer than I'd like.
          There are roughly three ways to discover food:
        </p>
  
        <ol style={{ listStyleType: 'decimal' }}>
          <li>Recommendations from friends.</li>
          <li>Wandering around in person</li>
          <li>Data points from the internet.</li>
        </ol>
  
        <p>
          The first two aren't so hackable. You can ask for plenty of recommendations and save them in Google Maps, or spend more time researching before you go. 
          In reality, the internet is the single source of truth.
        </p>
  
        <p>
          I’ve noticed many friends constantly zooming around Google Maps, chasing high ratings
          or finding a blog that happens to have landed in the top few search results.
          Often, this squinting into a tiny iPhone screen is happening on the side of a road in Bolivia or Bangkok whilst
          dodging pedestrians and buses.
        </p>
  
        <p>
          I built this app because I realised you usually just want to find the best nearby place 
          fast. It’s not that you can’t use Google Maps or read the blogs but there can be suprising amount of effort perusing
          exising data to get there. A single tap that simply says: “Here are the highest-rated places within 1 km of you, sorted and ready to go.”
        </p>
        <p>
          Marco. Pollo.
        </p>
        <p>
          <strong>marcopollo.jacklp.com</strong>
        </p>
      </main>
    );
  };
  
  export default MarcoPollo;
  